import styled from "styled-components";
import Variables from "../../assets/styleVariables";
export const Box = styled.div`
  .add-file-big {
    width: 88px;
    height: 88px;
    border-radius: 4px;
    border: ${Variables.colors.complementary_500} dashed 1px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 6px;
    cursor: pointer;
    i {
      color: ${Variables.colors.complementary_700};
      &:before {
        margin-left: 0;
        font-size: 20px;
      }
    }
  }
  .files-number {
    cursor: pointer;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    top: calc(50% - 16px);
    right: calc(50% - 16px);
    color: ${Variables.colors.complementary_800};
    ${props => {
      if (!props.withoutFile) {
        return `
            &:hover{
                background-color: ${Variables.colors.complementary_400};
            }
        `;
      }
    }}
  }
  .files {
    display: flex;
    flex-wrap: wrap;
    .image-slider-file {
      ${props => {
        if (props.viewWidth) {
          const size = (props.viewWidth - (4 - 1) * 6) / 4; //4 n each row
          return `
           height:${size}px;
           width:${size}px;`;
        } else {
          return `height:64px;
                  width:64px;`;
        }
      }};
      min-width: 104px;
      height: 104px;
      border-radius: 4px;
      border: ${Variables.colors.complementary_400} solid 1px;
      overflow: hidden;
      position: relative;
      margin: 0 6px 4px;
      //background-size: cover;
      //background-repeat: no-repeat;
      //background-position: center;
      cursor: pointer;

      .image-slider-img {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
      }
      .refresh-button-container {
        display: none;
        font-size: 12px;
        color: ${Variables.colors.complementary_600};
        position: absolute;
        padding: 8px;
        z-index: 99;
        width: 100%;
        height: 100%;
        top: 0;
        right: 0;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        img {
          width: 24px;
          height: 24px;
        }
      }
      i {
        width: 32px;
        height: 32px;
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0.7);
        color: ${Variables.colors.complementary};
        position: absolute;
        bottom: 8px;
        right: 8px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        &:before {
          margin-left: 0;
        }
      }
    }
  }
`;
export const CarouselSlider = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  display: ${props => (props.show ? "block" : "none")};
  background-color: rgba(0, 0, 0, 0.8);
  top: 0;
  right: 0;
  z-index: 99999;
  & > .header {
    display: flex;
    justify-content: space-between;
    padding: 16px 32px;
    direction: ltr;
    height: 40px;
    i {
      color: ${Variables.colors.complementary};
      cursor: pointer;
      &:before {
        font-size: 20px;
      }
    }
  }
  .path {
    padding: 48px;
    display: flex;
    height: calc(100% - 140px);
    justify-content: center;
    align-items: center;
    width: 100%;
    .next,
    .prev {
      width: 48px;
      height: 96px;
      background-color: rgba(256, 256, 256, 0.2);
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        color: rgba(256, 256, 256, 0.4);
        &:before {
          font-size: 38px;
          margin: 0;
        }
      }
    }
    .next {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      //here
      position: absolute;
      left: 0;
    }
    .prev {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      position: absolute;
      right: 0;
    }
    //img {
    //  height: 100%;
    //}
    .image-slider-file {
      position: relative;
      height: 100%;
      width: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        height: auto;
        width: auto;
        max-width: 100%;
        max-height: 100%;
      }
      .refresh-button-container {
        display: none;
        font-size: 14px;
        width: 100px;
        color: ${Variables.colors.complementary_600};
        position: absolute;
        padding: 8px;
        z-index: 99999;
        top: calc(50% - 64px / 2);
        right: calc(50% - 92px / 2);
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
  .error-message-container {
    color: ${Variables.colors.complementary}!important;
  }
  & > .footer {
    background-color: rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    img.image-slider-img {
      border-radius: 4px;
      margin: 8px;
      cursor: pointer;
      width: 72px;
      height: 72px;
      border: solid 1px ${Variables.colors.complementary_400};
      &.selected {
        width: 78px;
        height: 78px;
      }
    }
  }
`;
